import React from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";

import LectureContainer from "./LectureContainer";
import CompleteLecture from "./CompleteLecture";
import TotalLecture from "./TotalLecture";
import CompleteRate from "./CompleteRate";

function PlanStudy({ menuLink, planStudyList, titleText, menuTypeCode, info, drawCd }) {
    const totalLectureInfo = planStudyList?.find((info) => info.TYPE === "TOTAL_CNT");
    const completeLectureInfo = planStudyList?.find((info) => info.TYPE === "COMP_CNT");
    const completeRateInfo = planStudyList?.find((info) => info.TYPE === "COMP_PER");

    return (
        <SubBoxWrapper
            info={info}
            titleText={titleText}
            menuLink={menuLink}
            menuTypeCode={menuTypeCode}
            customClassName={"plan"}
            drawCd={drawCd}
        >
            <LectureContainer menuLink={menuLink}>
                <CompleteLecture
                    completeLectureCount={completeLectureInfo ? completeLectureInfo?.CNTT : 0}
                    completeRate={completeRateInfo.CNTT}
                />
                <TotalLecture
                    totalLectureCount={totalLectureInfo ? totalLectureInfo?.CNTT : 0}
                    titleText={totalLectureInfo ? totalLectureInfo?.NAME : null}
                />
            </LectureContainer>
            <LectureContainer menuLink={menuLink}>
                <CompleteRate
                    completeRate={completeRateInfo ? completeRateInfo?.CNTT : 0}
                    titleText={completeRateInfo ? completeRateInfo?.NAME : null}
                />
            </LectureContainer>
        </SubBoxWrapper>
    );
}

export default PlanStudy;
